(function () {
  var revealItems = document.querySelectorAll('.reveal');

  if ('IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.16, rootMargin: '0px 0px -42px 0px' });

    revealItems.forEach(function (item) {
      revealObserver.observe(item);
    });
  } else {
    revealItems.forEach(function (item) {
      item.classList.add('is-visible');
    });
  }

  var counters = document.querySelectorAll('[data-counter]');

  function splitCounterText(text) {
    var match = text.trim().match(/^(\d+)(.*)$/);
    if (!match || text.indexOf('-') !== -1) return null;
    return {
      target: parseInt(match[1], 10),
      suffix: match[2] || ''
    };
  }

  function animateCounter(element) {
    var original = element.textContent;
    var counter = splitCounterText(original);
    if (!counter || element.dataset.counted === 'true') return;

    element.dataset.counted = 'true';
    var duration = counter.target > 100 ? 1200 : 900;
    var start = performance.now();

    function tick(now) {
      var progress = Math.min((now - start) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      var value = Math.round(counter.target * eased);
      element.textContent = value + counter.suffix;

      if (progress < 1) {
        requestAnimationFrame(tick);
      } else {
        element.textContent = original;
      }
    }

    requestAnimationFrame(tick);
  }

  if ('IntersectionObserver' in window) {
    var counterObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          animateCounter(entry.target);
          counterObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.55 });

    counters.forEach(function (counter) {
      counterObserver.observe(counter);
    });
  } else {
    counters.forEach(animateCounter);
  }

  var hero = document.querySelector('[data-cool-hero]');
  if (hero && window.matchMedia('(min-width: 760px)').matches) {
    window.addEventListener('scroll', function () {
      var y = window.scrollY || window.pageYOffset;
      hero.style.setProperty('--hero-shift', Math.min(y * 0.08, 38) + 'px');
    }, { passive: true });
  }

  document.querySelectorAll('[data-finder]').forEach(function (finder) {
    var options = finder.querySelectorAll('[data-title]');
    var title = finder.querySelector('[data-finder-title]');
    var text = finder.querySelector('[data-finder-text]');
    var link = finder.querySelector('[data-finder-link]');

    options.forEach(function (option) {
      option.addEventListener('click', function () {
        options.forEach(function (item) {
          item.classList.remove('is-active');
          item.setAttribute('aria-selected', 'false');
        });

        option.classList.add('is-active');
        option.setAttribute('aria-selected', 'true');
        title.textContent = option.dataset.title;
        text.textContent = option.dataset.text;
        link.href = option.dataset.link;
        link.textContent = option.dataset.label;
      });
    });
  });

  document.querySelectorAll('.product-form select[name="id"]').forEach(function (select) {
    var gallery = document.querySelector('[data-product-gallery]');
    var price = document.querySelector('[data-price]');

    function setActiveVariantMedia() {
      var selectedOption = select.options[select.selectedIndex];
      if (!selectedOption) return;

      if (price && selectedOption.dataset.variantPrice) {
        price.textContent = selectedOption.dataset.variantPrice;
      }

      var assetName = selectedOption.dataset.galleryAsset;
      if (!gallery || !assetName) return;

      var productCard = gallery.querySelector('[data-media-role="product"]');
      var productImage = productCard && productCard.querySelector('img');
      if (productCard && productImage && selectedOption.dataset.galleryUrl) {
        productImage.src = selectedOption.dataset.galleryUrl;
        productCard.dataset.galleryAsset = assetName;
      }

      var target = null;
      gallery.querySelectorAll('.product-gallery__item').forEach(function (item) {
        item.classList.remove('is-current');
        if (item.dataset.galleryAsset === assetName) {
          target = item;
        }
      });

      if (target) {
        target.classList.add('is-current');
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'start'
        });
      }
    }

    select.addEventListener('change', setActiveVariantMedia);
    setActiveVariantMedia();
  });

  var mobileMenus = document.querySelectorAll('.mobile-nav');
  mobileMenus.forEach(function (menu) {
    menu.querySelectorAll('.mobile-nav__panel a').forEach(function (link) {
      link.addEventListener('click', function () {
        menu.removeAttribute('open');
      });
    });
  });

  document.addEventListener('click', function (event) {
    mobileMenus.forEach(function (menu) {
      if (menu.hasAttribute('open') && !menu.contains(event.target)) {
        menu.removeAttribute('open');
      }
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    mobileMenus.forEach(function (menu) {
      menu.removeAttribute('open');
    });
  });
}());
